import localStorage from 'redux-persist/lib/storage';

export default localStorage;
